export class Size2 {
    constructor(public width: number, public height: number) {
    }

    public static fromElement(element: HTMLElement): Size2 {
        return new Size2(element.offsetWidth, element.offsetHeight);
    }
}
